import React, { Suspense, lazy } from 'react';
import { useU3204DebouncedValue } from '../../hooks/useU3204DebouncedValue';

const U3204MarkdownRenderer = lazy(() => import('./U3204MarkdownRenderer'));

const U3204_MARKDOWN_STREAM_DEBOUNCE_MS = 80;

interface U3204MarkdownContentProps {
  content: string;
  isStreaming?: boolean;
}

const U3204MarkdownContent: React.FC<U3204MarkdownContentProps> = ({ content, isStreaming = false }) => {
  const debouncedContent = useU3204DebouncedValue(content, U3204_MARKDOWN_STREAM_DEBOUNCE_MS, isStreaming);
  const renderContent = isStreaming ? debouncedContent : content;

  return (
    <Suspense
      fallback={
        <span className="whitespace-pre-wrap text-sm leading-relaxed text-foreground">{content}</span>
      }
    >
      <U3204MarkdownRenderer content={renderContent} />
    </Suspense>
  );
};

export default U3204MarkdownContent;
